export enum Attitude {
  Negative = -1,
  Neutral = 0,
  Positive = 1,
}
